
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'SiteInformation',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup() {
    }
});
